import { createSlice } from "@reduxjs/toolkit";

export interface IEnums {}
const initialState: IEnums = {};

const enumsSlice = createSlice({
  name: "enums",
  initialState,
  reducers: {
    setEnums: (state, action) => {
      state = action.payload;
      return state;
    },
  },
});

export default enumsSlice;
